exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav_item {\r\n    padding: 0px 20px; \r\n    font-weight: bold;\r\n    cursor: pointer;\r\n}\r\n\r\n.nav-item.active {\r\n    color: #0099ff;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/oomph/oom-header/oom-header.component.css
// module id = ../../../../../src/app/components/oomph/oom-header/oom-header.component.css
// module chunks = main